var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouVeTried(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.6 16.3c0-.3-.2-.6-.4-.8-.2-.2-.5-.3-.9-.3l-1.3.1c-.9-3.7-3.9-6.4-8.3-7.2h-1.5c-2 .3-3.8 1.1-5.3 2.4-1.5 1.3-2.5 3-3 4.8h-1.3c-.3 0-.6.1-.9.3-.2.2-.4.5-.4.8-.4 2.6-2.3 20.1-.8 21.4 1 1.3 6.7 2.2 12.5 2.4 5.7-.1 11.4-1 12.5-2.4 1.4-1.4-.5-18.9-.9-21.5zM16.4 38.4l-2-.4 1-20.4c0-1.7.5-3.3 1.5-4.8 1-1.4 2.4-2.5 4-3.2-2.1 2.3-3.4 5.2-3.7 8.2l-.8 20.6zM24 15.7c-1.3 0-3.4-.1-5.5-.2.8-3 2.8-6.1 5.2-6.6h.4c2.6.5 4.5 3.7 5.2 6.6-1.9.1-4 .2-5.3.2zm7.6 22.7-1-20.8c-.2-3-1.4-5.8-3.5-8 1.6.7 3 1.8 4 3.2 1 1.4 1.5 3.1 1.5 4.7l1 20.4c-.6.2-1.3.3-2 .5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouVeTried);
export default __webpack_public_path__ + "static/media/you_ve-tried.3fcff4a88e41b6be6fbb1ddafad2d92a.svg";
export { ForwardRef as ReactComponent };